import React from "react";

//icons
import { IconLibrary } from "../../../../interfaces/icon/IconLibrary";
import Icon from "../../../global/icons/Icon";



export interface ILikeButton {
    isDisabled?: boolean, 
    ariaLabel: string, 
    onButtonClick: any, 
    includeText: boolean, 
    isActive: boolean,
    colour?: string,
    className?: string,
    buttonText?: string
}

const LikeButton = ({isDisabled, ariaLabel, onButtonClick, includeText, isActive, colour, className, buttonText}: ILikeButton) => {
    const text : string = isActive ? "Liked" : "Like"

    return (
        <button
            className={`social-like-button ${className ?? ""}`}
            disabled={isDisabled}
            aria-label={ariaLabel}
            onClick={onButtonClick}
        >
            <Icon iconName={isActive ? IconLibrary.LIKE_ACTIVE : IconLibrary.LIKE} sizeInPx="12" color={colour}/>
            {includeText && (buttonText ?? text)}        
        </button>
    );
};

export default LikeButton